import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { ChangeControlActionPlan } from '../models/change-control-action-plan';
import { ExtendedActionItem } from '../models/extend-action-item';

@Injectable({
  providedIn: 'root'
})
export class ActionPlanService {
  typesList: any[] = [];
  usersList: any = [];

  constructor(private httpClient: HttpClient) { }

  getTypes(): Observable<any> {
    let observable: Observable<any>;
    if (this.typesList.length > 0) {
      observable = of(this.typesList);
    }
    else {
      observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetTypes_Api)
        .pipe(
          tap(typesData => this.typesList = typesData)
        );
    }
    return observable;
  }

  getUsersLookUpData(scopes: any, scopeChange: boolean): Observable<any> {
    const requestPayload = { scopes: scopes };
    let observable: Observable<any>;
    // If there is a scope change, we need to get updated userList
    if(scopeChange){
      this.usersList = [];
      observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetUserLookUp_Api, {params : requestPayload})
          .pipe(
            tap(usersData => this.usersList = usersData)
          );
    }
    else{
      if (this.usersList.length > 0) {
        observable = of(this.usersList);
      }
      else {
        observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetUserLookUp_Api, {params : requestPayload})
          .pipe(
            tap(usersData => this.usersList = usersData)
          );
      }
    }
    return observable;
  }

  uploadFile(file: File, foldername: string): Observable<any> {
    const formData = new FormData();
    formData.append(file.name, file);
    return this.httpClient.post(
      ApiConstants.Files_Upload_Api + foldername, formData);
  }

  saveActionPlan(actionPlan: ChangeControlActionPlan): Observable<any> {
    return this.httpClient.post(
      ApiConstants.ActionItem_SaveActionPlanApi,
      actionPlan
    );
  }

  getCreatedActionPlanAndActionItems(actionPlanId: string, actionItemIds: string[]): Observable<any> {
    return this.httpClient.post(
      ApiConstants.ActionItem_GetCreatedActionPlanAndActionItems.replace('{actionPlanId}', actionPlanId),
      actionItemIds
    );
  }

  getActionPlanForCC(CCNumber: string) : Observable<any>{
    return this.httpClient.get(ApiConstants.ActionItem_GetActionItems + '/' + `${CCNumber}`);
  }

  // download attachment from Action Item
  downloadFile(fileId: string) : Observable<any> {
    return this.httpClient.get(ApiConstants.Files_Download_Api + `${fileId}`);
  }

  updateActionItem(extendActionItem: ExtendedActionItem) : Observable<any>{
    return this.httpClient.put(ApiConstants.ActionItem_UpdateActionItem, extendActionItem);
  }


}
